export function setElementAttrs(el: Element, attrs: { [key: string]: string }) {
    for (const key in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, key)) {
            el.setAttribute(key, attrs[key]);
        }
    }
  }